import { scope } from '../../providers/GigerProvider/useTheme.js';

const getSidePanelFooterStyles = scope(theme => ({
  position: 'sticky',
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: theme.palette.white,
  display: 'flex',
  borderTop: `1px solid ${theme.palette.gray[200]}`,
  padding: theme.spacing(2),
  paddingLeft: 0
}));
const getFiltersFooterButtonStyles = scope(theme => ({
  flex: '1',
  justifyContent: 'center',
  marginLeft: theme.spacing(2)
}));

export { getFiltersFooterButtonStyles, getSidePanelFooterStyles };
//# sourceMappingURL=SidePanelDefaultFooterStyles.js.map
